import React from 'react';
import styled from '@emotion/styled';
import BaseTabs from '@material-ui/core/Tabs';
import BaseTab from '@material-ui/core/Tab';
import { createTheme } from '@material-ui/core/styles';
import theme from '../../themes/default';

export const DateTimePickerTheme = createTheme({
  typography: {
    fontFamily: theme.font.family.workSans,
    useNextVariants: true,
  },
  palette: {
    primary: {
      main: theme.color.purple3,
    },
    text: {
      hint: theme.color.grey11,
    },
  },
  overrides: {
    MuiPickersCalendarHeader: {
      iconButton: {
        color: theme.color.designSystem.blackOpacity60,
        margin: `0 ${theme.spacing.xSmall}`,
        '&:disabled': {
          color: theme.color.designSystem.blackOpacity38,
        },
      },
    },
    MuiPickersDay: {
      day: {
        borderRadius: theme.borderRadius.medium,
        fontSize: theme.font.size.copy,
        color: theme.color.designSystem.blackOpacity87,
      },
      dayDisabled: {
        color: theme.color.designSystem.blackOpacity38,
      },
    },
  },
});

export const Tabs = styled((props) => (
  <BaseTabs {...props} classes={{ indicator: 'indicator', fixed: 'fixed' }} />
))`
  & .indicator {
    background-color: ${theme.color.purple3};
    min-width: 40px;
  }

  & .fixed {
    height: 40px;
  }
`;

export const Tab = styled((props) => (
  <BaseTab {...props} classes={{ selected: 'selected', wrapper: 'wrapper' }} />
))`
  display: flex;
  flex: 1;
  text-transform: none;
  font-weight: normal;
  padding: 0px;
  height: 40px;
  min-width: 40px;
  min-height: 0px;
  font-size: ${theme.font.size.copy};
  &.selected {
    color: ${theme.color.purple3};
  }
  & > span.wrapper > span {
    padding-left: ${theme.spacing.small};
    padding-right: ${theme.spacing.small};
  }
`;

export const Container = styled('div')`
  display: flex;
  flex-direction: column;
  width: 304px;
  overflow-x: hidden;
`;

export const TimeContainer = styled('div')`
  margin-bottom: ${theme.spacing.large};
`;

export const CalendarContainer = styled('div')``;

export const YearsContainer = styled('div')``;
